import React from "react";

function TitleValue(title) {
  return (
    <div>
      <span style={{ fontWeight: "500", fontSize: "17px" }}>{title}</span>
    </div>
  );
}

export default TitleValue;
